import { Portal, Root as TooltipPrimitiveRoot, Trigger as TooltipPrimitiveTrigger } from "@radix-ui/react-tooltip";
import React from "react";
import { SIZES } from "./constants";
import { BaseTooltipArrow, BaseTooltipContent } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// todo fix this type
var BaseTooltip = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var ariaLabel = props.ariaLabel,
    children = props.children,
    content = props.content,
    isOpen = props.isOpen,
    onOpenChange = props.onOpenChange,
    preferredSide = props.preferredSide,
    preferredAlignment = props.preferredAlignment,
    showArrow = props.showArrow;
  var arrowHeight = SIZES.arrowHeight,
    arrowWidth = SIZES.arrowWidth,
    offsetWithArrow = SIZES.offsetWithArrow,
    offsetWhenArrowHidden = SIZES.offsetWhenArrowHidden;
  var sideOffset = showArrow ? offsetWithArrow : offsetWhenArrowHidden;
  return /*#__PURE__*/_jsxs(TooltipPrimitiveRoot, {
    open: isOpen,
    onOpenChange: onOpenChange,
    children: [/*#__PURE__*/_jsx(TooltipPrimitiveTrigger, {
      ref: forwardedRef,
      asChild: true,
      children: children
    }), /*#__PURE__*/_jsx(Portal, {
      children: /*#__PURE__*/_jsxs(BaseTooltipContent, {
        sideOffset: sideOffset,
        "aria-label": ariaLabel,
        side: preferredSide,
        align: preferredAlignment,
        children: [content, showArrow && /*#__PURE__*/_jsx(BaseTooltipArrow, {
          width: arrowWidth,
          height: arrowHeight
        })]
      })
    })]
  });
});
BaseTooltip.displayName = "BaseTooltip";
export default BaseTooltip;